import React from "react";
import styled from "styled-components";
import { Paragraph14Regular } from "../../../../../common/Typography/Paragraph14";
import Icon from "../../../../../common/components/Icon/Icon";

const Container = styled.div`
  align-self: flex-start;
  display: flex;
  padding-bottom: 109px;
`;

const Description = styled(Paragraph14Regular)`
  opacity: 0.7;
`;

const InfoIcon = styled(Icon)`
  transform: translateY(-2px);
  padding-right: 6px;
  opacity: 0.7;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding-right: 16px;
  }
`;

const SingupBoxInfoWeb = (props: any) => {
  const { children } = props;
  return (
    <Container>
      <InfoIcon name="info" />
      <Description>{children}</Description>
    </Container>
  );
};

export default SingupBoxInfoWeb;
